module.exports = __webpack_public_path__ + "img/4.3a1d99a8.png";